import { COMPLAINT_FORM_SET_VALID, COMPLAINT_FORM_SET_VALUE } from "../../../actions/customerComplaint/complaintArbitration"
import { complaintArbitrationRules } from "./complaintArbitration"

export const customerComplaintRules = (store, next, action) => {
    if (action.type.startsWith(COMPLAINT_FORM_SET_VALUE) || action.type.startsWith(COMPLAINT_FORM_SET_VALID)) {
        return complaintArbitrationRules(store, next, action);
    }
}
